
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quantum",
      function () {
        return require("private-next-pages/quantum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quantum"])
      });
    }
  